import { type FC } from 'react'
import classNames from 'classnames'
import { tagHueClass, WORKFLOW_CATEGORIES, type WorkflowCategoryKey } from '../workflowTags'

interface CategoryBadgeProps {
  category: WorkflowCategoryKey | null
}

export const CategoryBadge: FC<CategoryBadgeProps> = ({ category }) => {
  if (category === null) {
    return null
  }
  const { label, icon, hue } = WORKFLOW_CATEGORIES[category]
  return (
    <span
      className={classNames(
        'd-inline-flex align-items-center gap-1 zocks-px-0.75 zocks-py-0.125 rounded-2 paragraph-extra-small medium flex-shrink-0',
        tagHueClass(hue),
      )}
    >
      <i className={classNames('bi', icon)} aria-hidden='true' />
      {label}
    </span>
  )
}
